import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TermsAndConditions from "./TermsAndConditions";

function App() {
  return (
    <TermsAndConditions/>
    // <Router>
    //   <Routes>
    //     <Route path="/terms" element={<TermsAndConditions />} />
    //   </Routes>
    // </Router>
  );
}

export default App;
